<template>
	<div class="teachingMode">
		<div class="tm_main">
			<appListView
				ref="appListViewRef"
				v-show="showTag == 0"
				
			/>
      <!-- @sendMessage="sendMessage" -->
			<AppDetailView
				ref="AppDetailViewRef"
				
				:id="detailId"
				v-if="showTag == 1 && detailId"
			/>
      <!-- @sendMessage="sendMessage" -->
		</div>
	</div>
</template>

<script>
import AppDetailView from "./views/appDetailView.vue";
import appListView from "./views/appListView.vue";
// import * as Y from "yjs";
// import { WebsocketProvider } from "y-websocket";
// import { v4 as uuidv4 } from "uuid";
export default {
	components: {
		appListView,
		AppDetailView,
	},
	data() {
		return {
			showTag: 0,
			detailId: null,
			doc: null,
			provider: null,
			yMessage: null,
			mId: null,
		};
	},
	methods: {
		changeShowTag(newTag) {
			this.showTag = newTag;
			this.$nextTick(() => {
				if (this.showTag == 0) {
					this.detailId = null;
					this.$refs.appListViewRef.getData();
				}
			});
		},
		changeDetailId(newId) {
			this.detailId = newId;
		},
		// messageInit() {
		// 	if (this.doc && !this.yMessage) {
		// 		console.log("获取message",this.doc,this.yMessage)
		// 		this.yMessage = this.doc.getArray("message");
		// 		this.yMessage.observe((e) => {
		// 			e.changes.added.forEach((i) => {
		// 				const message = i.content.getContent()[0];
		// 				console.log("yMessage", message);
		// 				let _nowTime = new Date();
		// 				let _msgTime = new Date(message.timestamp);
		// 				if (
		// 					_nowTime-_msgTime<=1000*10 &&
		// 					message.mId != this.mId
		// 				) {
		// 					//1分钟
		// 					this.getMessages(message);
		// 				}
		// 			});
		// 		});
		// 	}
		// },
		// sendMessage(obj) {
		// 	if (this.doc && this.yMessage) {
		// 		let message = obj;
		// 		obj.timestamp = new Date().toISOString()
		// 		obj.mId = this.mId
		// 		this.doc.transact(() => {
		// 			this.yMessage.push([message]);
		// 		});
		// 	}
		// },
		// getMessages(msgObj) {
		// 	console.log("message", msgObj);
		// 	let type = msgObj.type;
		// 	if (["changeAppData"].includes(type)) {
		// 		//更新指定app
		// 		let id = msgObj.id;
		// 		this.$refs.appListViewRef.getDataByIdAndUpdate(id);
		// 		if (this.detailId === id) this.$refs.AppDetailViewRef.getData();
		// 	}
		// 	if (["changeTeachingWorks"].includes(type)) {
		// 		if (this.detailId && this.showTag == 1) {
		// 			let id = msgObj.id;
		// 			let tid = msgObj.tid;
		// 			this.$refs.AppDetailViewRef.$refs.studentCardRef.updateStudentData(
		// 				id,tid
		// 			);
		// 		}
		// 	}
		// },
	},
	mounted() {
		// if (this.$store.state.yWebsocket && !this.doc) {
			
		// 	this.doc = new Y.Doc();
		// 	this.provider = new WebsocketProvider(
		// 		this.$store.state.yWebsocket,
		// 		"teachingSpace",
		// 		this.doc
		// 	);

		// 	this.provider.on("status", (event) => {
		// 		console.log("👉",event.status);
		// 		if (event.status == "connected") {
		// 			console.log("👉连接成功websocket(teachingMode)");
		// 			this.mId = uuidv4();
		// 			this.messageInit();
		// 		}
		// 	});
		// }
	},
};
</script>

<style lang="scss" scoped>
.teachingMode {
	width: 100%;
  height: 100%;
	min-height: calc(100vh - 50px);
	overflow: auto;
	display: flex;
	justify-content: center;
	background-color: #f9f8f8;
	.tm_main {
		width: 80%;
		//min-width: 1520px;
		min-width: 800px;
		height: auto;
	}
}
</style>
